import * as t from 'ts-codec';
import { AnyCodec, Decoded } from 'ts-codec';
import { TokenWrapper } from '../../util/TokenWrapper';
import { PaginatedResponse } from '@foxbun/lib-goferal-types';
import { AbstractClient, AbstractClientOptions, PostParams } from '@foxbun/lib-sdk';

export interface BaseApiClientOptions extends AbstractClientOptions {
  token_wrapper: TokenWrapper;
}

export class BaseApiClient extends AbstractClient {
  constructor(protected options2: BaseApiClientOptions) {
    super(options2);
  }

  protected paginate<Req extends t.AnyCodec, Res extends t.AnyCodec>(args: {
    path: string;
    req?: Req;
    codec?: Res;
    params?: t.Decoded<Req>;
    token?: string;
  }) {
    let self = this;

    return {
      generator: async function* generator() {
        let more = true;
        let cursor = args.params.cursor;
        while (more) {
          const res = await self.post({
            ...args,
            params: {
              ...args.params,
              cursor: cursor
            },
            res: PaginatedResponse(args.codec)
          });

          yield res.items;
          more = res.more;
          cursor = res.cursor;
        }
      },
      call: () => {
        return self.post({
          ...args,
          params: {
            ...args.params,
            cursor: args.params.cursor
          },
          res: PaginatedResponse(args.codec)
        });
      }
    };
  }

  protected async post<Req extends AnyCodec, Res extends AnyCodec>(
    args: PostParams<Req, Res> & { buffered?: boolean }
  ): Promise<Decoded<Res>> {
    let token = await this.options2.token_wrapper.getToken();
    return super.post({
      ...args,
      token
    });
  }
}
